export default __webpack_public_path__ + "maps-examples-dds-circle-layer-thumbnail-480-80ebf683364b0e731301f16f246d8995.png";